import { BaseApiClient } from "./base/base-api-client";

export class BackendApiClient extends BaseApiClient {
    constructor(path: string) {
        super(path);
    }
}
